var MATCH = require('./_wks')('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_fails-is-regexp.js
// module id = 386
// module chunks = 1